<!--
 * @FileDescription: 侧边栏菜单
 * @Author: 陈文景
 * @Date: 2022-09-22 14:30:32
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>
    <template v-if="!item.children.length">
      <el-menu-item v-if="item.ifShow === 1" :index="item.path">
        <i v-if="item.icon" :class="item.icon" />
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>

    <el-submenu v-else :index="item.path" popper-append-to-body>
      <template slot="title">
        <i v-if="item.icon" :class="item.icon" />
        <span slot="title">{{ item.name }}</span>
      </template>
      <sidebar-item v-for="child in item.children" :key="child.id" :item="child" />
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
}
</script>
